import 'polyfills'

import {
  Accordion,
  AuthForm,
  CategoryNavigation,
  CookieHubIcon,
  ExpandableCard,
  MobileMenu,
  RadioCard,
  HeroSlider,
  Modal,
  Pillar,
  ToggleCard,
  Tabs,
  SelectSubmit,
  StyleGuide,
  ProductBar,
  ProductTradeIn,
  Product,
  UserTooltip,
  ProductTooltip,
  UserManagementTooltip,
  MailingList,
  SpecialOrder,
  SelectAutoFill,
  ProductImagesSlider,
  CategoryCard,
  ProductListNavigation,
  BatchOrder,
  Search,
  CategoryCardFilter,
  ProductListSlider,
  SpecialOfferPopup,
  // LoginPage,
  /*  DroppLocations,*/
} from 'components'
import {
  CheckoutSummary,
  CheckoutInformation,
  SideCart,
  CheckoutShipping,
  CheckoutPayment,
  Cart,
  CartRecycle,
  CheckoutInsurance,
  PaymentStatus,
} from './checkout'
import { SideSection } from './components/product-crosssell'
import { ProductCard } from './components/product-card'
import { AccountSalesForm } from './components/account-sales-form'
import { WaitingPage } from './components/waiting-page'

const el = {
  accordions: document.querySelectorAll<HTMLDivElement>('.accordion'),
  authForm: document.querySelector<HTMLDivElement>('.auth-form'),
  radioCards: document.querySelectorAll<HTMLDivElement>('.radio-card'),
  toggleCards: document.querySelectorAll<HTMLLabelElement>('.toggle-card'),
  categoryNavigation: document.querySelector<HTMLDivElement>('.category-navigation'),
  expandableCards: document.querySelectorAll<HTMLDivElement>('.expandable-card'),
  formsWithSelectSubmit: document.querySelectorAll<HTMLFormElement>(
    'form[data-select="submit"]'
  ),
  tabs: document.querySelectorAll<HTMLDivElement>('.tabs-container'),
  pillars: document.querySelectorAll<HTMLLabelElement>('.pillar'),
  swipers: document.querySelectorAll<HTMLDivElement>('.hero-slider-block'),
  mailingLists: document.querySelectorAll<HTMLFormElement>('.mailing-list-form'),
  accountSales: document.querySelectorAll<HTMLFormElement>('.account-sales-form'),
  selectAutoFills: document.querySelectorAll<HTMLSelectElement>(
    '.select-auto-fill select'
  ),
  categoryCards: document.querySelectorAll<HTMLAnchorElement>('.category-card'),
  searchPopup: document.querySelectorAll<HTMLAnchorElement>('.search-popup__suggestions'),
  categoryCardFilters: document.querySelectorAll('.category-product-filter'),
  productListSLiders: document.querySelectorAll('.product-slider'),
  sidesectionLinks: document.querySelectorAll<HTMLAnchorElement>('.sidesection__link'),
  sidesectionCatLinks: document.querySelectorAll<HTMLAnchorElement>(
    '.product-category-link'
  ),
  productCards: document.querySelectorAll<HTMLDivElement>('.product-card'),
}

const app = {
  init(): void {
    el.accordions.length && el.accordions.forEach((target) => Accordion(target))
    el.authForm && AuthForm.init()
    el.radioCards.length && el.radioCards.forEach((target) => RadioCard(target))
    el.toggleCards.length && el.toggleCards.forEach((target) => ToggleCard(target))
    el.categoryNavigation && CategoryNavigation(el.categoryNavigation)
    el.formsWithSelectSubmit.length &&
      el.formsWithSelectSubmit.forEach((target) => SelectSubmit(target))
    el.tabs.length && el.tabs.forEach((target) => Tabs(target))
    el.pillars.length && el.pillars.forEach((target) => Pillar(target))
    el.swipers.length && el.swipers.forEach((target, i) => HeroSlider(target, i))
    el.mailingLists.length && el.mailingLists.forEach((target) => MailingList(target))
    el.accountSales.length &&
      el.accountSales.forEach((target) => AccountSalesForm(target))
    el.selectAutoFills.length &&
      el.selectAutoFills.forEach((target) => SelectAutoFill(target))
    el.categoryCards.length && el.categoryCards.forEach((target) => CategoryCard(target))

    el.productListSLiders.length &&
      el.productListSLiders.forEach((target) => ProductListSlider(target))
    el.sidesectionLinks.length &&
      el.sidesectionLinks.forEach((target) => SideSection(target))
    el.sidesectionCatLinks.length &&
      el.sidesectionCatLinks.forEach((target) => SideSection(target))

    el.categoryCardFilters.length &&
      el.categoryCardFilters.forEach((target) => CategoryCardFilter(target))
    el.productCards.length && el.productCards.forEach((target) => ProductCard(target))
    el.expandableCards.length &&
      el.expandableCards.forEach((target) => ExpandableCard(target))

    BatchOrder.init()
    Cart.init()
    CartRecycle.init()
    CheckoutInformation.init()
    CheckoutInsurance.init()
    CheckoutPayment.init()
    CheckoutShipping.init()
    /*    DroppLocations.init()*/
    CheckoutSummary.init()
    CookieHubIcon.init()
    MobileMenu.init()
    Modal.init()
    Product.init()
    ProductTradeIn.init()
    ProductBar.init()
    SideCart.init()
    SpecialOrder.init()
    StyleGuide.init()
    UserTooltip.init()
    ProductTooltip.init()
    ProductImagesSlider.init()
    PaymentStatus.init()
    ProductListNavigation.init()
    Search.init()
    SpecialOfferPopup.init()
    // LoginPage.init()
    UserManagementTooltip.init()
    WaitingPage.init()
  },
}

document.addEventListener('DOMContentLoaded', (): void => {
  setTimeout((): void => {
    document.querySelector('.body').classList.remove('preload')
  }, 100)

  app.init()
})
